// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__S+del","loaderImg":"Loader_loaderImg__ueMu4","wobble-pulse":"Loader_wobble-pulse__QVuj4","loaderStarting":"Loader_loaderStarting__iFv3V"};